<template>
   
    <div class="clearfix company-form-container company-form-container-warapper">
        <b-overlay :show="showoverlay" rounded="sm" class='trustee-overlay'>
        <div class="company-form-container-title-wrapper">
            <div class="col-sm-12 px-3 company-form-box-title">Leavers Awaiting Settlement from Provident Fund</div>
        </div>
        <div class="col-md-12 company-form-container-content-wrapper">
            <div v-if="em_reg_custom_list_2.length>0">
                <common-list :action_btn_text="action_btn_text" :pageurl="this.$api_url" :is_action=0 :checkbox="checkbox" :is_pf="is_n_pf"   :appended_column="em_reg_appended_column" :key="em_reg_list_key" :company_options="em_reg_company_options" :employees="em_reg_custom_list_2" :default_column="em_reg_default_column" :primary_key="em_reg_primary_key" v-on:childToParent="listReturn_2"></common-list>
            </div>
            <div v-else>
                <div v-if="settlement_loader" class="list-no-data">
                    <span class="d-block text-center">Looking for relevant data..</span>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div v-else class="list-no-data">
                    Looks like there is no employee to show.
                </div>
            </div>
        </div>
        </b-overlay>
        <b-modal size="lg" class='pf-dereg-details-modal' id="bv-modal-process-settlement-2" hide-footer :title="'Provident Fund Particulars for '+curr_emp_name">
            <b-overlay :show="showoverlay" class='showoverlay' rounded="sm">
                <div class="d-block">
                    <b-form>                    
                        <div class="clearfix">   
                            <div class="row clearfix">
                            <div class="col-md-12 float-left">    
                                <div class="card-body">
                                    <div class="employee-table-wrapper">
                                        
                                        <table class="employee-list-table dataTable table-overflow table-sticky">
                                    
                                        <thead>
                                        <tr class="table-head">
                                            <td class="text-center">
                                                Particulars
                                            </td>
                                            <td class="text-center">
                                                Balance (BDT)
                                            </td>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Employer’s contribution to PF
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_salary_fund_employer)}}
                                            </td>
                                            
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Employee’s contribution to PF
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_salary_fund_employee)}}
                                            </td>
                                            
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Profit balance on employer’s contribution
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_profit_fund_employer)}}
                                            </td>
                                            
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Profit balance on employee’s contribution
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_profit_fund_employee)}}
                                            </td>
                                           
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Forfeiture balance on employer’s contribution
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_forfeiture_fund_employer)}}
                                            </td>
                                            
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Forfeiture balance on employee’s contribution
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_forfeiture_fund_employee)}}
                                            </td>
                                            
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Advance balance
                                            </td>
                                            <td class="text-right">
                                                ({{formatMoney(curr_emp_loan_total)}})
                                            </td>
                                            
                                        </tr>
                                        <tr  class="hover-bg table-row">
                                            <td class="text-left">
                                                Total
                                            </td>
                                            <td class="text-right">
                                                {{formatMoney(curr_emp_pf_total_adjusted)}}
                                            </td>
                                            
                                        </tr>
                                        </tbody>
                                        </table> 
                                        
                                    </div> 
                                </div>    

                               

                                 
                            </div>  
                          </div>                           
                        </div>
                    
                       
                    </b-form> 
                </div>
            </b-overlay>
    </b-modal>
    </div>
</template>
 

<script>
    
    import moment from 'moment';
    export default{

        props: ['flg','pageurl'],
        data(){            
            let sortOrders = {};
            let columns = [
                            {label: 'Name', name: 'name' },
                            {label: 'Department', name: 'department'},
                            {label: 'Leave Date', name: 'leave_date'},
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});
        
            return {
                empty_result:'',
                settlement_loader:true,
                action_btn_text:'Details',
                min_date:'',
                date_min:'',
                settlementOptions: [{text:'Select Settlement Type',value:null},{text:'Final Settlement',value:'0'}, {text:'Partial Settlement',value:'1'}],
                cu:window.location.href,
                showoverlay:false,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                loading:'',
                unsettle_pf_id:'',
                readonly : false,
                trz_display_form : 'd-none',
                user_level : 0,
                has_changed : false,
                reset_flg : false,
                has_changed_flg : false,

                tab_one_error : false,
                tab_two_error : false,
                tab_three_error : false,
                disableme : false,
                disabled : false,
                disable_settlement_amount:true,
                is_n_pf:1,
                show_loader : true,
                show_loader_2 : true,
                show_loader_3 : true,
                show_loader_4 : true,

                formatted: '',
                selected: '',
                fake : 0,

                date_of_birth : '',
                date_of_joining : '',
                settlement_disable_msg : '',
                

                errormsg:[],
                

                xdata : {
                    
                },
                
                
                /*new vars */
                
                search:'',
                length: 10,
                length_options: [{ value: 10, text: "10" },{ value: 20, text: "20" },{ value: 30, text: "30" },{ value: 40, text: "40" },{ value: 50, text: "50" }],
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                temp_length: 10,
                

                columns: columns,
                sortKey: 'name',
                sortOrders: sortOrders,
                pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                
                
                emp_list_data : [],
                
                curr_emp_name: '',
                curr_emp_id: 0,
                curr_emp_pf_total: 0,
                curr_emp_loan_total: 0,
                curr_emp_pf_total_adjusted:0,


                curr_emp_salary_fund: 0,
                curr_emp_salary_fund_employer: 0,
                curr_emp_salary_fund_employee: 0,
                curr_emp_profit_fund: 0,
                curr_emp_profit_fund_employer: 0,
                curr_emp_profit_fund_employee: 0,
                curr_emp_forfeiture_fund: 0,
                curr_emp_forfeiture_fund_employer: 0,
                curr_emp_forfeiture_fund_employee: 0,

                curr_emp_settle_balance: 0,
                curr_emp_settle_balance_show: 0, 


                
                settlement_fdata : {
                  employee_id:0, 
                  application_id: 0,
                  settlement_amount: 0,
                  settlement_date: null, 
                  settlement_details:'',
                  settlement_status: null,  
                  salary_contribution:0,
                  salary_contribution_employer:0,
                  salary_contribution_employee:0,
                  profit_contribution:0,
                  profit_contribution_employer:0,
                  profit_contribution_employee:0,
                  forfeiture_contribution:0,    
                  forfeiture_contribution_employer:0, 
                  forfeiture_contribution_employee:0,                           
                },
                
                pf_from_disable:false,
                people: 0,
                blankmsg: '',
                
                application_lists: [],
                employeedata:[],
                edit_user:false,
                new_capability:true,
                
                department : [],                
                jobposition : [],
                branch : [],
                manager : [],
                leave_policies : [],

                employee_pic : '',
                form_pic:null,
                form_nid_scan:null,
                form_etin_scan:null,

                
                form_passport_scan:null,

                residency: [
                    { value: null, text: "Select..." },
                    { value: "Resident", text: "Resident" },
                    { value: "Non Resident", text: "Non Resident" }
                ],
                nationality: [
                    { value: null, text: "Select..." },
                    { value: "Bangladeshi", text: "Bangladeshi" },
                    { value: "Non Bangladeshi", text: "Non Bangladeshi" }
                ],
                gender:[
                    { value: null, text: "Select..." },
                    { value: "Male", text: "Male" },
                    { value: "Female", text: "Female" },
                    { value: "Third Gender", text: "Third Gender" },
                ],
                marital_status:[
                    { value: '', text: "Select..." },
                    { value: "Single", text: "Single" },
                    { value: "Married", text: "Married" },
                    { value: "Widower", text: "Widower" },
                    { value: "Divorced", text: "Divorced" },
                ],
 
                bankurl : this.$api_url+'/bankinfo/',  
                
                logoUrl : this.$api_url+'/images/employee/' + 'demo.jpg',
                logoUploaded: false,
                showLogoUploader: false,
                
                
                /**Child Component property data */

                is_action:1, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                list_key:0, /* Component Key */
                custom_list:[],  /* Data List */
                default_column:['name','email','jobposition'], /* Default Column List */
                            /* Appended Column List  and there title and type */
                primary_key:'employee_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */

                tmp_custom_list:[],

                custom_array:[],

                /***Child Component property data */

                /**Child Component property data */

                is_action:0, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                list_key:0, /* Component Key */
                application_list:[],  /* Data List */
                application_default_column:['name','employee_code','jobposition'], /* Default Column List */
                 application_appended_column:[
                     
                    { value: "de_reg_applied_date", text: "Application Date",type: "text"},
                    { value: "status", text: "Status",type: "text"},
                    ],                   /* Appended Column List  and there title and type */
                 application_primary_key:'id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                 application_company_options:[],         /* Company Filterable options */

                 application_tmp_custom_list:[],

                 application_custom_array:[],

                /***Child Component property data */

                em_reg_appended_column:[                 
                    
                    { value: "pf_start", text: "PF Start Date",type: "date"},
                    { value: "pf_end", text: "PF End Date",type: "date"},
                    { value: "status", text: "Status",type: "text"},
               
                ],       
                em_reg_company_options:[],
                em_reg_custom_list_2:[],
                em_reg_tmp_custom_list_2:[],
                em_reg_list_key:0, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                em_reg_list_key:0,
                em_reg_primary_key:'id',
                em_reg_default_column:['name','email','employee_code'], /* Default Column List */
                em_selected: [],
                checkbox:0,
                disable_amount:true,
                curr_update_id:'',
                curr_approve_date:'',
                curr_update_employee:'',
                pf_details:[],
                employee_info_new:[],
                pfoverlay:false,
                report_data:[],

            }
        },
        methods:{

            //Methods Start Here
            
            pfAwating: function(index_name='employee_dropdown')
            {
                this.em_reg_custom_list_2 = [];
                let currentObj = this;
                currentObj.show_loader_4 = true;
                
                axios.get(this.$api_url+'/pf/employee/reglist' , {
                    params: {
								  manual_de_registration: 1
							  }
    
                }).then(function(response){

                   
                

                //this.em_reg_tmp_custom_list_2 = [];
                currentObj.settlement_loader = false;
                if (typeof response.data.employee_data !== 'undefined')
                {
                    /* Assingning the list */ 
                    this.em_reg_tmp_custom_list_2 = response.data.employee_data;

                    /* Assingning the list */ 
                    this.em_reg_tmp_custom_list_2 = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));
                }
                if (typeof response.data.options !== 'undefined')
                {
                    /* Assingning the Options */ 
                    this.em_reg_company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));
                
                }
                

                /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
                

      

                if(this.em_reg_tmp_custom_list_2.length > 0 )
                {
                                
                        this.em_reg_tmp_custom_list_2.forEach(pelement => {
                            
                            let dops = []; 

                            let awating = []; 
                            let ii = 0; 
                            
                            if(pelement.employee_id > 0 && pelement.status != 'Settled')
                            {
                                pelement.pf_total = this.formatMoney(pelement.pf_total);
                                
                                
                                // if(pelement.pf_end == '0000-00-00' || pelement.pf_end == '' || pelement.last_payslip == null)
                                if(pelement.pf_end == '0000-00-00' || pelement.pf_end == '')
                                {
                                    pelement.pf_end ='';
                                
                                
                                }
                                else
                                { 
                                            pelement.status = 'Unsettled';
                                            
                                            this.em_reg_custom_list_2= this.em_reg_custom_list_2.concat(pelement);
                                            ii++;
                                           
                                     

                                }

                            }
                            else
                            {
                            
                            }
                        });

                    
                }
                else
                {
                    this.blankmsg = "No employee found to De-Register";
                }
                
            
            



                //this.reg_custom_list = this.reg_tmp_custom_list;
                this.em_reg_list_key = this.em_reg_list_key + 1;
                
                currentObj.show_loader_4 = false;
                }.bind(this)).catch(function (error){
                    currentObj.show_loader_4 = false;
                    console.log(error)
                });
            },
            toMoney: function(amount)
            {
                if(amount !="0")
                {
                        if(!isNaN(amount))
                        {
                            var number = Number(amount);
                            return number;
                        }
                    var NumWithoutCommas = amount.replace(/,/g, ''); 
                    var number = Number(NumWithoutCommas).toFixed(2);
                    return number;
                }else
                    return 0;
            },
            moneyFormat(amount)
            {
              if(amount && parseFloat(amount)>0){
                return amount.toLocaleString();
              }
              else
              return amount;
            },

            processSettlement2: function(employee_id)
            {

                let currentObj = this;
                currentObj.showoverlay = true;
                axios.get(this.$api_url+'/pf/employee/data' , {
                    params: {
								employee_id: employee_id,
							}
    
                }).then(function(response){

                    var temp_data = response.data.employee_data;
                    var item = temp_data[employee_id];
                    this.curr_emp_pf_total =item.pf_total;
                    this.curr_emp_loan_total = item.loan_adjustable;
                    this.curr_emp_pf_total_adjusted = this.toMoney(this.curr_emp_pf_total) - this.curr_emp_loan_total;
                    this.curr_emp_salary_fund = item.salary_fund + item.migrated_pf_company_contribution + item.migrated_pf_employee_contribution - item.final_salary_contribution_company - item.final_salary_contribution_employee - item.partial_salary_contribution_employee - item.partial_salary_contribution_company;
                    this.curr_emp_salary_fund_employer = item.employer_unregistered_provident_fund + item.migrated_pf_company_contribution - item.final_salary_contribution_company - item.partial_salary_contribution_company;
                    this.curr_emp_salary_fund_employee = item.employee_unregistered_provident_fund + item.migrated_pf_employee_contribution - item.final_salary_contribution_employee - item.partial_salary_contribution_employee;
                    
                    this.curr_emp_profit_fund = item.profit_fund + item.migrated_pf_profit_employee_contribution + item.migrated_pf_profit_company_contribution - item.final_profit_contribution_employee - item.final_profit_contribution_company - item.partial_profit_contribution_employee - item.partial_profit_contribution_company;

                    this.curr_emp_profit_fund_employer = item.employee_profit_distrtibuted_fund_company + item.migrated_pf_profit_company_contribution - item.final_profit_contribution_company - item.partial_profit_contribution_company;

                    this.curr_emp_profit_fund_employee = item.employee_profit_distrtibuted_fund_employee + item.migrated_pf_profit_employee_contribution - item.final_profit_contribution_employee - item.partial_profit_contribution_employee;

                    this.curr_emp_forfeiture_fund = item.forfeiture_fund + item.migrated_pf_forfeiture_employee_contribution + item.migrated_pf_forfeiture_company_contribution - item.final_forfeiture_contribution_employee - item.final_forfeiture_contribution_company - item.partial_forfeiture_contribution_employee - item.partial_forfeiture_contribution_company;

                    this.curr_emp_forfeiture_fund_employer = item.employee_forfeiture_distrtibuted_fund_company + item.migrated_pf_forfeiture_company_contribution - item.final_forfeiture_contribution_company - item.partial_forfeiture_contribution_company;

                    this.curr_emp_forfeiture_fund_employee = item.employee_forfeiture_distrtibuted_fund_employee + item.migrated_pf_forfeiture_employee_contribution - item.final_forfeiture_contribution_employee  - item.partial_forfeiture_contribution_employee;

                    this.$bvModal.show('bv-modal-process-settlement-2');
                    currentObj.showoverlay = false;

                    }.bind(this)).catch(function (error){
                    currentObj.showoverlay = false;
                    console.log(error)
                });
                
                
            },
            listReturn_2:function(data)
            {
                if(data.trustee == 1)
                {
                    this.curr_emp_name = data.name;
                    this.processSettlement2(data.employee_id);
                }

            },
            validateState(ref)
            {
                if ( this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated) ) 
                {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            pfDetailsNew: function(employee_id)
            { 
                if(employee_id>0){
                let currentObj = this;
                
                let formData = new FormData();
                formData.append('employee_id', employee_id); 
                formData.append('viewmode', 1);
                formData.append('d_type', 'excel'); 
                this.pfoverlay = true;
                this.report_data = [];
                this.pf_details = [];
                this.employee_info_new = [];
                
                axios.post(this.$api_url + '/pf/report/profile', formData)
                    .then(function (response) 
                    {
                        this.report_data = response.data.file_name;
                        this.employee_info_new = response.data.file_name.employee_info;
                        this.pf_details = response.data.file_name.data;
                        this.pfoverlay = true;
                    }.bind(this))
                    .catch(function (error) 
                    {
                        console.log(error);
                    }); 

                }
            },
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }
                
            //     return money;
            // }, 
           
        },
        created: function(){
            if(!this.checkNet()) return false;
            this.$validator.reset();
            this.pfAwating();
        }
    }
</script>

